
/* eslint-disable import/no-extraneous-dependencies, import/prefer-default-export */
import { writable } from "svelte/store";
import { videoEditStore } from './videoEdit'

const videoDetailStore = writable({});

export  {
  videoEditStore,
  videoDetailStore,
}


